/**
 * Integration list table for DP Operator Console.
 * Per INTEGRATIONS_ARCHITECTURE.md §6.1.
 */
import { useTranslation } from 'react-i18next';

const HEALTH_BADGE = {
  healthy: { bg: 'bg-green-100 dark:bg-green-900/30', text: 'text-green-700 dark:text-green-400', label: 'Healthy' },
  failing: { bg: 'bg-red-100 dark:bg-red-900/30', text: 'text-red-700 dark:text-red-400', label: 'Failing' },
  degraded: { bg: 'bg-yellow-100 dark:bg-yellow-900/30', text: 'text-yellow-700 dark:text-yellow-400', label: 'Degraded' },
  unknown: { bg: 'bg-gray-100 dark:bg-gray-800', text: 'text-gray-500 dark:text-gray-400', label: 'Unknown' },
  disabled: { bg: 'bg-gray-100 dark:bg-gray-800', text: 'text-gray-400', label: 'Disabled' },
};

export default function IntegrationListTable({ integrations, onEdit, onTest, onDisable }) {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-[var(--aif-border-default)] text-left text-xs text-[var(--aif-text-muted)] uppercase tracking-wider">
            <th className="py-2 px-3">Provider</th>
            <th className="py-2 px-3">Type</th>
            <th className="py-2 px-3">Status</th>
            <th className="py-2 px-3">Health</th>
            <th className="py-2 px-3">Credentials</th>
            <th className="py-2 px-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {integrations.map((intg) => {
            const health = HEALTH_BADGE[intg.health_status] || HEALTH_BADGE.unknown;
            return (
              <tr key={intg.id} className="border-b border-[var(--aif-border-subtle)] hover:bg-[var(--aif-bg-elevated)] transition">
                <td className="py-3 px-3 font-medium">{intg.provider}</td>
                <td className="py-3 px-3">{intg.integration_type}</td>
                <td className="py-3 px-3">
                  {intg.enabled
                    ? <span className="text-green-600 dark:text-green-400 text-xs font-medium">Active</span>
                    : <span className="text-gray-400 text-xs">Disabled</span>
                  }
                </td>
                <td className="py-3 px-3">
                  <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${health.bg} ${health.text}`}>
                    {health.label}
                  </span>
                </td>
                <td className="py-3 px-3">
                  {intg.has_credentials
                    ? <span className="text-green-600 dark:text-green-400 text-xs">Configured</span>
                    : <span className="text-red-500 text-xs font-medium">Missing</span>
                  }
                </td>
                <td className="py-3 px-3 flex gap-2">
                  <button onClick={() => onEdit(intg)} className="text-xs text-[var(--aif-color-primary)] hover:underline">Edit</button>
                  <button onClick={() => onTest(intg.id)} className="text-xs text-blue-500 hover:underline">Test</button>
                  {intg.enabled && (
                    <button onClick={() => onDisable(intg.id)} className="text-xs text-red-500 hover:underline">Disable</button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
